import { useContext } from 'react'
import styled from 'styled-components'

import { Typography, Paragraph, Box, Icon } from '@telus-uds/components-web'
import Headset from '@telus-uds/palette-allium/build/web/icons/Headset'
import { array } from 'prop-types'
import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import { formatCurrency } from '../../../utils/currency'

const Container = styled(Box).attrs(() => ({
  gap: 3,
  display: 'inline-flex'
}))`
  padding-bottom: 8px;
  svg {
    margin-top: 3px;
  }
`

const FinancedAccessoryExistingBalanceMessage = ({ financedAccessoryPenalties }) => {
  const { lang } = useContext(localeContext)
  const translate = useTranslate()

  if (financedAccessoryPenalties.length <= 0) return null

  return (
    <Container data-testid="af-existing-balance-message">
      <Icon icon={Headset} variant={{ size: 'tiny' }} />
      <Paragraph variant="medium">
        <Typography variant={{ size: 'medium' }}>
          {translate('accessoryFinancing.existingBalanceMessage.prefix')}
          <Typography variant={{ size: 'medium', bold: true }} data-di-mask>
            {formatCurrency(financedAccessoryPenalties[0]?.amount, lang)}
          </Typography>
          {translate('accessoryFinancing.existingBalanceMessage.suffix')}
        </Typography>
      </Paragraph>
    </Container>
  )
}

export default FinancedAccessoryExistingBalanceMessage

FinancedAccessoryExistingBalanceMessage.propTypes = {
  financedAccessoryPenalties: array.isRequired
}
